import { deepClone, debounce } from '@lsfe/tools';

const collectedEnumList = new Set([]); // 收集到的字典code list
const allEnumListMap = {}; // 所有字典数据的map
let vmList = []; // 所有用到数据字典的实例

const fetchData = debounce(that => {
    // 在函数作用域定义一份list
    const list = vmList;
    // 清空vmList，防止对下一次decounce产生影响
    vmList = [];
    that.$hPost('/api/m/tms/mapi/dictionary/batchGetDictionaryAndValue', {
        dicCodes: [...that.collectedEnumList]
    }).then(data => {
        list.forEach(vm => {
            vm.handleEnumRes && vm.handleEnumRes(data[vm.dicCode]);
        });
        Object.keys(data).forEach(key => {
            that.$set(that.allEnumListMap, key, data[key].dictionaryValueList.map(item => {
                return {
                    label: item.name,
                    value: item.key,
                };
            }));
        });
    });
}, 500);


export default {
    props: {
        dicCode: {
            type: String
        },
        dicAllValue: {
            type: [Number, String]
        },
        responseProcessor: Function
    },
    data() {
        return {
            collectedEnumList,
            allEnumListMap,
            // curDicList: {},
            // curDicMap: {},
        };
    },
    computed: {
        getData() {
            let result = this.data;
            if (this.dicCode) {
                const list = this.allEnumListMap[this.dicCode];
                if (this.dicAllValue && list) {
                    list.unshift({ label: '全部', value: this.dicAllValue });
                }
                result = list;
            }
            if (this.responseProcessor && result) {
                return this.responseProcessor(deepClone(result));
            }
            return result;
        }
    },
    created() {
        const { dicCode, collectedEnumList } = this;
        if (dicCode) {
            collectedEnumList.add(dicCode);
            vmList.push(this);
            fetchData(this);
        }
    }
};
